<!-- identity-layout.component.html -->
<div id="identity-header">
  <div class="color-line"></div>
</div>

<div id="identity-content">
  <router-outlet></router-outlet>
</div>
